import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'value-getter-renderer',
    template: ` <span [matTooltip]="displayTooltip ? valueToDisplay : ''">{{ valueToDisplay }}</span> `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ValueGetterRendererComponent implements ICellRendererAngularComp {
    protected valueToDisplay!: string;
    protected displayTooltip = true;

    public agInit(params: ValueGetterRendererParams): void {
        this.valueToDisplay = this.valueGetter(params);
        this.displayTooltip = params.displayTooltip;
    }

    private valueGetter(params: ValueGetterRendererParams): any {
        const { getValueFunction } = params;
        return getValueFunction ? getValueFunction(params.value, params.data) : params.value;
    }

    refresh(): boolean {
        return false;
    }
}
export interface ValueGetterRendererParams<TData = any, TValue = any> extends ICellRendererParams<TData, TValue> {
    getValueFunction: (value: TValue, data?: TData) => string;
    displayTooltip: boolean;
}
